module.exports = __webpack_public_path__ + "img/02n.fc573d47.png";